import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  colorUnique: null,
  color: null,
  colorPickerVisible: false,
  alias: {},
};

const doorSlice = createSlice({
  name: "color",
  initialState,
  reducers: {
    setColorUnique(state, action) {
      state.colorUnique = action.payload;
    },
    setColor(state, action) {
      state.color = action.payload;
    },
    showColorPicker(state, action) {
      state.colorPickerVisible = action.payload;
    },
    setAlias(state, action) {
      state.alias = action.payload;
    },
  },
});

export const { setColorUnique, setColor, showColorPicker, setAlias } = doorSlice.actions;

export default doorSlice.reducer;
